export default {
  noActiveRecipe: 'Brak aktywnego przepisu w komorze {chamber}.',
  noDataSourceConnected: 'W tej komorze brakuje połączenia z kontrolerem ProTherm. Połączenie można nawiązać w systemie zarządzania zasobami.',
  goToNextStep: 'Przejdź do kroku {step}',
  goToPreviousStep: 'Powrót do kroku {step}',
  goToNextStepConfirm: 'Przejść do kroku {step}?',
  goToPreviousStepConfirm: 'Wrócić do kroku {step}?',
};
